import type { ComponentProps } from "react";
import { DashboardView } from "@/components/dashboard/dashboard-view";
import { useLoaderData } from "react-router";
import { load } from "../api/load";

// Everything the dashboard shows comes from the server in one call.
type DashboardData = Omit<ComponentProps<typeof DashboardView>, "now">;

export function loader() {
  return load<DashboardData>(`/api/v1/admin/dashboard`);
}

export default function DashboardPage() {
  const {
    metrics,
    dailyExpenses,
    topCategories,
    recentSignups,
    recentExpenses,
    unresolvedFeedback,
  } = useLoaderData() as DashboardData;
  const now = new Date();

  return (
    <div className="mx-auto flex max-w-[1400px] flex-col gap-5 px-6 py-6">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[22px] font-semibold tracking-tight text-fc-text">
            Dashboard
          </div>
          <div className="mt-1 text-[13px] text-fc-text-dim">
            refreshed just now
          </div>
        </div>
      </div>

      <DashboardView
        metrics={metrics}
        dailyExpenses={dailyExpenses}
        topCategories={topCategories}
        recentSignups={recentSignups}
        recentExpenses={recentExpenses}
        unresolvedFeedback={unresolvedFeedback}
        now={now}
      />
    </div>
  );
}
